export default "__VITE_ASSET__BEq6P5fE__"